import { combineReducers } from 'redux';
import translationReducer from './languages/Translation/reducer';

export const rootReducer = combineReducers({
  translation: translationReducer,
});